"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const $ = require("jquery");
const dom_utils_1 = require("../../../../utils/dom-utils");
const cards = (0, dom_utils_1.queryAll)('.member-re');
const cardsBtn = (0, dom_utils_1.queryAll)('.member-re__btn');
const windowWidth = $(window).width();
document.addEventListener('DOMContentLoaded', () => {
    if (windowWidth && windowWidth > 992) {
        cards.forEach((card) => {
            card.addEventListener('click', () => {
                activateCard(card);
                switchBtn(card.querySelector('.member-re__btn'));
            });
        });
    }
    cardsBtn.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (windowWidth && windowWidth > 992) {
                btn.classList.contains('member-re__btn--active') ? activateCard() : activateCard(btn.closest('.member-re'));
            }
            btn.classList.contains('member-re__btn--active') ? switchBtn() : switchBtn(btn);
        });
    });
});
const activateCard = (card) => {
    cards.forEach((card) => {
        card.classList.remove('member-re--active');
        switchBio(card, 'data-bio');
    });
    if (card) {
        card.classList.add('member-re--active');
        switchBio(card, 'data-full-bio');
        scrollToActiveCard(card);
    }
};
const switchBtn = (target) => {
    cardsBtn.forEach((btn) => {
        btn.classList.remove('member-re__btn--active');
        btn.innerHTML = 'Read More';
    });
    if (target) {
        target.classList.add('member-re__btn--active');
        target.innerHTML = 'Read Less';
    }
};
const switchBio = (card, attribute) => {
    card.querySelector('.member-re__bio').innerHTML = card.getAttribute(attribute);
};
const scrollToActiveCard = (card) => {
    card.scrollIntoView({ behavior: 'smooth', block: 'center' });
};
